import { render, staticRenderFns } from "./pacakage-card-order.vue?vue&type=template&id=20300280&scoped=true&"
import script from "./pacakage-card-order.vue?vue&type=script&lang=js&"
export * from "./pacakage-card-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20300280",
  null
  
)

export default component.exports